import {AbstractService} from 'services/AbstractService';
import sortingToString from 'services/utils/sortingToString';

import _ from 'lodash';

_.noConflict();

const ORDER_DETAILS_URL = '/api/orders/{0}';
const ORDER_PERIODS_LIST_URL = '/api/orders/{0}/periods';

const PROJECT_ORDERS_LIST_SIMPLE_URL = '/api/projects/{0}/orders/simple';
const PROJECT_ORDERS_LIST_URL = '/api/projects/{0}/orders';
const ACCOUNT_ORDERS_LIST_SIMPLE_URL = '/api/orders/simple';

const ACCOUNT_ORDERS_DETAILED_LIST_URL = '/api/orders/inherited';
const ACCOUNT_PERIODS_DETAILED_LIST_URL = '/api/orders/periods/inherited';


const ACCOUNTS_ORDERS_DOWNLOAD_URL = '/download/orders/xlsx?{0}';
const ACCOUNTS_PERIODS_DOWNLOAD_URL = '/download/orders/periods/xlsx?{0}';

const PROJECT_PERIODS_LIST_URL = '/api/projects/{0}/orders/periods';

const MASS_ORDER_ACTIONS_URL = '/api/orders/periods';
const MASS_ORDER_PROLONG_URL = '/api/orders/prolong';

export class OrdersService extends AbstractService {

  get (accountId, orderId) {
    return this.client.get(ORDER_DETAILS_URL.format(orderId), {}, {accountId});
  }

  async getProjectOrdersListSimple ({accountId, projectId, dateStart, dateEnd}) {
    return await this.client.get(PROJECT_ORDERS_LIST_SIMPLE_URL.format(projectId), {
      start_date: dateStart,
      end_date: dateEnd
    }, {accountId});
  }

  async getProjectOrdersList ({
    accountId, projectId, dateStart, dateEnd, per_page, page, withVat, filterId,
    search, channelIds, sorting, totalByRange = false}) {

    return await this.client.get(PROJECT_ORDERS_LIST_URL.format(projectId), {
      start_date: dateStart,
      end_date: dateEnd,
      with_vat: withVat,
      channel_id: channelIds,
      search,
      id: filterId,
      per_page,
      page,
      total_by_range: totalByRange,
      sorting: sortingToString(sorting)
    }, {accountId});
  }

  deleteProjectOrdersList (accountId, projectId, orderIds) {
    return this.client.delete(
      PROJECT_ORDERS_LIST_URL.format(projectId),
      {
        id: orderIds
      }
    );
  }

  deletePeriods (accountId, orderId, periodsIds) {
    return this.client.delete(
      MASS_ORDER_ACTIONS_URL,
      {},
      {
        order_id: orderId,
        periods: periodsIds.map(id => ({id}))
      },
      {accountId}
    );
  }

  async getProjectOrderPeriodsList ({accountId, orderId, withVat}) {
    return await this.client.get(ORDER_PERIODS_LIST_URL.format(orderId), {with_vat: withVat}, {accountId});
  }

  async getProjectPeriodsList ({accountId, projectId, dateStart, dateEnd, withVat, channelIds = null}) {
    return await this.client.get(PROJECT_PERIODS_LIST_URL.format(projectId), {
      start_date: dateStart,
      end_date: dateEnd,
      with_vat: withVat,
      channel_id: channelIds
    }, {accountId});
  }

  async getAccountOrdersListSimple ({accountId}) {
    return await this.client.get(ACCOUNT_ORDERS_LIST_SIMPLE_URL, {}, {accountId});
  }

  async getAccountsOrdersListSimple (accountIds) {
    return (await this.client.get(
      ACCOUNT_ORDERS_LIST_SIMPLE_URL,
      {account_id: accountIds}
    )).items;
  }

  async getAccountOrdersList ({
    accountId,
    accountIds,
    dateStart,
    dateEnd,
    projectId,
    channelIds,
    withVat,
    page,
    search,
    per_page,
    unassigned,
    manager,
    sorting
  }, axiosParams = {}) {
    let sortParam;
    if (sorting) {
      const sortDirection = sorting.direction === 'asc' ? '' : '-';
      sortParam = `${sortDirection}${sorting.name}`;
    }

    return await this.client.get(
      ACCOUNT_ORDERS_DETAILED_LIST_URL,
      {
        account_id: accountIds,
        start_date: dateStart,
        end_date: dateEnd,
        project_id: projectId,
        with_vat: withVat,
        channel_id: channelIds,
        manager_id: manager,
        entity: 'order',
        page,
        per_page,
        name: search,
        unassigned,
        sorting: sortParam
      },
      {accountId},
      axiosParams
    );
  }

  getAccountOrderPeriodsList (
    {
      accountId,
      accountIds,
      dateStart,
      orderIds,
      dateEnd,
      projectId,
      channelIds,
      withVat,
      page,
      per_page,
      unassigned,
      manager_id,
      sorting
    }, axiosParams = {}
  ) {
    let sortParam;
    if (sorting) {
      const sortDirection = sorting.direction === 'asc' ? '' : '-';
      sortParam = `${sortDirection}${sorting.name}`;
    }

    return this.client.get(
      ACCOUNT_PERIODS_DETAILED_LIST_URL,
      {
        account_id: accountIds,
        start_date: dateStart,
        end_date: dateEnd,
        project_id: projectId,
        with_vat: withVat,
        channel_id: channelIds,
        order_id: orderIds,
        entity: 'period',
        page,
        per_page,
        unassigned,
        manager_id,
        sorting: sortParam
      }, {accountId}, axiosParams);
  }


  async massCreateAndUpdateOrders (accountId, orders) {
    return this.client.put(
      MASS_ORDER_ACTIONS_URL,
      {orders},
      {accountId}
    );
  }

  prolongOrders (accountId, payload) {
    return this.client.post(
      MASS_ORDER_PROLONG_URL,
      payload
    );
  }

  getAccountOrdersOrPeriodsInXLSXFormat ({
    accountId,
    withVat,
    fields,
    startDate,
    endDate,
    entity,
    selectedIds,
    sorting,
    apiToken
  }) {

    let entityParam;
    let requestUrl;

    if (entity === 'orders') {
      entityParam = 'order';
      requestUrl = ACCOUNTS_ORDERS_DOWNLOAD_URL;
    } else if (entity === 'periods') {
      entityParam = 'period';
      requestUrl = ACCOUNTS_PERIODS_DOWNLOAD_URL;
    }

    let sortParam;
    if (sorting) {
      const sortDirection = sorting.direction === 'asc' ? '' : '-';
      sortParam = `${sortDirection}${sorting.name}`;
    }

    const params = new URLSearchParams({
      ..._.pickBy({
        account_id: accountId,
        with_vat: withVat,
        start_date: startDate,
        end_date: endDate,
        entity: entityParam,
        id: selectedIds,
        sorting: sortParam,
        fields,
        'api-token': apiToken
      }, _.identity)
    });

    window.location.href = requestUrl.format(params.toString());
  }
}
